
import { Component } from 'vue-property-decorator';
import ElementBase from '../ElementBase';
import { ClassMap } from '../../configuration/ElementConfiguration';
import { ActivityStatusSumsTree } from '../../../backend/backendapi';
import PieChart from "./PieChart";

@Component({
  name: 'ActivityStatusSumTable',
  components: { PieChart },
})
export default class ActivityStatusSumTable extends ElementBase {
  private root: ActivityStatusSumsTree | null = null;
  readonly selectedPath: ActivityStatusSumsTree[] = [];

  get entries(): ActivityStatusSumsTree[] {
    if (this.root == null) {
      return [];
    } else if (this.selectedPath.length === 0) {
      return [this.root];
    } else {
      return this.selectedPath[this.selectedPath.length - 1].children;
    }
  }

  constructor() {
    super();
    this.lastDataUpdate = new Date(0);
    this.timeoutSeconds = 120;
  }

  async mounted(): Promise<void> {
    await super.mounted();
    this.enableTimeout();
  }

  public onInformationPush(elementPath: string, json: string): void {
    super.onInformationPush(elementPath, json);

    if (elementPath !== this.elementPath) {
      return;
    }

    const update = JSON.parse(json);
    Object.entries(update).forEach(([key, value]) => {
      if (key === 'activityStatusSumsTree') {
        this.root = value as ActivityStatusSumsTree;

        //update selectedPath with new elements
        const newSelectedPath: ActivityStatusSumsTree[] = [];
        let elements = [this.root! as ActivityStatusSumsTree];
        for (let i = 0; i < this.selectedPath.length; i++) {
          const oldPathElement = this.selectedPath[i];
          const newPathElement = elements.find(e => e.accountId == oldPathElement.accountId);
          if (newPathElement) {
            newSelectedPath.push(newPathElement);
            elements = newPathElement.children;
          } else {
            break;
          }
        }

        this.selectedPath.splice(0);
        this.selectedPath.push(...newSelectedPath);

        this.lastDataUpdate = new Date();
      }
    });
  }

  protected defaultClass(): ClassMap {
    return Object.assign({}, super.defaultClass(), { 'table': true, 'table-striped': true });
  }

  getConsolidated(entry: ActivityStatusSumsTree, fn: (tree: ActivityStatusSumsTree) => number): number {
    return fn(entry) + entry.children.map(e => this.getConsolidated(e, fn)).reduce((l, r) => l + r, 0);
  }
}
